<template>
  <v-list-tile
    v-if="menuItem.visible"
    :id="menuItem.id"
    :key="menuItem.id"
    active-class="red--text text--darken-2"
    v-bind="menuItem.href ? {
      ref: 'noopener noreferrer',
      target: '_blank',
      href: menuItem.href
    } : menuItem.route ? {
      to: menuItem.route,
      exact: true
    } : undefined"
    @click="menuItem.onClick ? menuItem.onClick() : undefined"
  >
    <v-list-tile-action>
      <v-icon>{{ menuItem.icon }}</v-icon>
    </v-list-tile-action>

    <v-list-tile-content class="subheading">
      <v-list-tile-title>{{ menuItem.title }}</v-list-tile-title>
    </v-list-tile-content>

    <v-chip
      v-if="menuItem.counter > 0"
      class="v-chip--x-small"
      :color="menuItem.counterClasses"
    >{{ menuItem.counter }}</v-chip>
  </v-list-tile>
</template>

<script>
  export default {
    name: 'NavigationMenuItem',
    props: {
      menuItem: {
        required: true,
        type: Object
      }
    }
  }
</script>
